import React from 'react'
import DeadlinesEdit from './ENotices2/NoticeSection';

function Index(
    {
        expanded
    }) {
    return (
        expanded && <DeadlinesEdit/>
    )
}

export default Index;